{
    "TargetreportformatLabel": "CSV-exportformaat",
    "TargetreportformatPdfOptionLabel": "PDF-document",
    "TargetreportformatRtfOptionLabel": "RTF-document",
    "TargetreportformatCsvOptionLabel": "CSV-exportformaat",
    "UselanguageLabel": "Gebruik taal:",
    "UselanguageEnusOptionLabel": "Engels Verenigde Staten)",
    "UselanguageEngbOptionLabel": "Engels Verenigd Koninkrijk)",
    "PapersizeLabel": "Papiergrootte:",
    "PapersizeA4OptionLabel": "A4 (210 mm x 297 mm)",
    "PapersizeLegalOptionLabel": "Juridisch (8½\" x 14\")",
    "PapersizeLetterOptionLabel": "Brief (8½\" x 11\")",
    "Format_SectionHeader": "Format",
    "NAME": "Format",
    "TargetreportformatXlsOptionLabel": "XLS exporteren"
}